// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { Uploader } from 'vant';
import VConsole from 'vconsole';
if (process.env.NODE_ENV !== 'production') {
  let vConsole = new VConsole()
  Vue.use(vConsole)
}
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Uploader);
import 'vant/lib/index.css';
import store from './store'// 引入vuex文件
import globalHeader from './components/globalHeader.vue'
import regionList from './components/regionList.vue'
import './assets/style/common.css'
import pinyin from 'js-pinyin'

import {unique} from './utils/index'
Vue.prototype.$store = store // 挂载vue原形上
Vue.config.productionTip = false
Vue.use(Vant);
Vue.component('globalHeader',globalHeader)   // 全局注册头部公共组件
Vue.component('regionList',regionList)   // 全局注册头部公共组件
// const dsBridge = require('dsbridge')
// Vue.prototype.$dsBridge = dsBridge
/* eslint-disable no-new */
// // main.js
// const currentVersion = '1.0.0'; // 当前版本号

// if (localStorage.getItem('appVersion') !== currentVersion) {
//   localStorage.setItem('appVersion', currentVersion);
//   window.location.reload(true); // 强制刷新
// }
// 创建一个事件总线
Vue.prototype.$bus = new Vue();
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js